<template>
  <b-server-table
    :key="tableRenderKey"
    :filter-props="{
      filterMap: [{ key: 'search' }],
    }"
    :headers="employeeHeaders"
    :request-func="userList">
    <template #action-button>
      <v-btn @click="openCreateDialog">
        <v-icon class="mr-1">mdi-plus</v-icon>
        <span>Створити співробітника</span>
      </v-btn>
    </template>
    <template #item.fullName="{ item }">
      <button class="link" type="button" @click="openEmployeeCard(item)">
        {{ item.surname }} {{ item.name }} {{ item.patronymic }}
      </button>
    </template>
    <template #item.birthDay="{ item }">
      {{ new CustomDate(item.birthDate).toString() || '---' }}
    </template>
    <template #item.position="{ item }">
      {{ item.position || '---' }}
    </template>
    <template #item.phone="{ item }">
      {{ item.phone || '---' }}
    </template>
    <template #item.email="{ item }">
      {{ item.email || '---' }}
    </template>
    <template #item.inn="{ item }">
      {{ item.inn || '---' }}
    </template>
    <template #item.isActive="{ item }">
      <v-chip :color="item.isActive ? 'success' : 'error'">
        <span class="font-weight-bold">{{
          item.isActive ? 'Активний' : 'Звільнений'
        }}</span>
      </v-chip>
    </template>
  </b-server-table>
</template>
<script lang="ts">
import { ref } from 'vue'
import { openDialog } from '@/dialog'
import { BServerTable } from 'best-modules/components/index'
import { CustomDate } from 'best-modules/utils'
import { userList } from '@/requests/user'
import { openUserCardDialog } from '@/utils/userCardDialog'
import { User } from '@/utils/types/user'

const employeeHeaders = [
  { key: 'fullName', title: 'ПІБ' },
  { key: 'birthDay', title: 'Дата народження' },
  { key: 'inn', title: 'ІПН' },
  { key: 'position', title: 'Посада' },
  { key: 'isActive', title: 'Статус' },
  { key: 'phone', title: 'Телефон' },
  { key: 'email', title: 'Пошта' },
]

export default {
  name: 'EmployeeList',
  components: { BServerTable },
  data: () => ({
    employeeHeaders,
    CustomDate,
  }),
  methods: { userList },
  setup() {
    const tableRenderKey = ref(1)

    const openEmployeeCard = (item: User) => {
      openUserCardDialog({
        userId: item.id,
        mode: 'employee',
        context: 'admin',
        title: `${item.surname || ''} ${item.name || ''} ${
          item.patronymic || ''
        }`.trim(),
        cb: () => {
          tableRenderKey.value += 1
        },
      })
    }

    const openCreateDialog = () => {
      openDialog({
        name: 'User',
        action: 'create',
        params: {
          cb: () => (tableRenderKey.value += 1),
        },
      })
    }

    return { openCreateDialog, openEmployeeCard, tableRenderKey }
  },
}
</script>

<style scoped></style>
